import { atom } from 'jotai'

export const liveToolbarAtom = atom<{ container: HTMLElement; shouldHide: boolean } | null>(null)
